import React from "react";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";
import { DATA_DN_STATUS, DATA_DN_PAYMENT_STATUS } from "../data/options";
import { Alert, Group } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons";
import _ from "lodash";
import moment from "moment";
import ReactJson from "react-json-view";

export default function DebitNoteSummary({ form, name }) {
  const [cellRender] = useCellRender();
  const dn = form.values;
  const keyParticulars = dn.particulars?.filter((p) => p.isKey);

  const status = DATA_DN_STATUS.find((s) => s.value === dn?.status);
  const paymentStatus = DATA_DN_PAYMENT_STATUS.find(
    (s) => s.value === dn?.paymentStatus
  );

  const showHandler =
    process.env.REACT_APP_GI_SHOW_HANDLER &&
    process.env.REACT_APP_GI_SHOW_HANDLER === "true";

  const showPolicyStatus =
    process.env.REACT_APP_DEBIT_NOTE_ADD_FORM_SHOW_POLICY_STATUS === "true";

  const fields = [
    {
      title: "Code",
      value: dn.code,
    },

    {
      title: "Status",
      value: status ? (
        <Group>
          {cellRender.Order.status(dn?.status)}
          {status?.label}
        </Group>
      ) : (
        "Unknown"
      ),
    },
    {
      title: "Payment Status",
      value: paymentStatus ? (
        <Group>
          {cellRender.Order.status(dn?.paymentStatus)}
          {paymentStatus?.label}
        </Group>
      ) : (
        "Unknown"
      ),
    },

    {
      title: "Insurer",
      value: dn.provider ? dn.provider.name : "-",
    },
    {
      title: "Class",
      value: dn.productType ? dn.productType.name : "-",
    },
    {
      title: "Product",
      value: dn.product ? dn.product.name + dn.product.cname : "-",
    },
    {
      title: "Policy Number",
      value: !dn.policyNumber ? "-" : dn.policyNumber,
    },
    { title: "Created By", value: cellRender.User(dn?.createdBy) },
    { title: "Type", value: dn.type },
  ];

  if (showPolicyStatus) {
    fields.push({ title: "Policy Status", value: dn.policyStatus });
  }
  if (dn.type === "RENEW") {
    fields.push({ title: "Renewal Count", value: dn.renewalCount });
  }

  if (dn.signedBy && showHandler) {
    fields.push({ title: "Handler 1", value: cellRender.User(dn?.signedBy) });
  }
  if (dn.signedBy2 && showHandler) {
    fields.push({ title: "Handler 2", value: cellRender.User(dn?.signedBy2) });
  }

  if (dn.particulars && dn.particulars.length > 0) {
    for (const p of dn.particulars.filter((p) => p.isKey)) {
      fields.push({
        title: p.title,
        value: p.detail,
      });
    }
  }

  return (
    dn && (
      <>
        {/* <ReactJson
          src={dn.particulars}
          collapsed
          style={{ background: "white" }}
        /> */}
        <InfoGridList fields={fields} values={dn} />
      </>
    )
  );
}
